import React from 'react'
import clsx from 'clsx'

// The Home gradient CTA — the primary action on every journey screen.
export function PrimaryButton({ className = '', children, ...props }) {
  return (
    <button
      className={clsx(
        'w-full transform rounded-xl bg-gradient-to-r from-emerald-600 to-teal-600 py-4 text-lg font-bold text-white shadow-lg transition hover:-translate-y-0.5 hover:from-emerald-700 hover:to-teal-700 hover:shadow-xl focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-60 disabled:hover:translate-y-0',
        className,
      )}
      {...props}
    >
      {children}
    </button>
  )
}

export default PrimaryButton
